document.addEventListener('DOMContentLoaded', function () {
    var Swiper = window.Swiper;
    var isMobile = window.innerWidth < 758;
    var secondSlideDesktop = null;
    function toggleSecondSlideDesktop(action, element) {
        var secondSlide = element.querySelector(`.swiper-slide:nth-child(2)`);
        if (secondSlide) {
            if (action === 'remove') {
            secondSlideDesktop = secondSlide.cloneNode(true);
            secondSlide.remove();
            } else if (action === 'restore') {
            var firstSlide = element.querySelector(`.swiper-slide:nth-child(1)`);
            if (firstSlide && secondSlideDesktop) {
                firstSlide.insertAdjacentElement('afterend', secondSlideDesktop);
            }
            }
        }
        }

    function initializeSwiper(swiperElement, productId) {
        var swiper = new Swiper(swiperElement, {
          direction: 'horizontal',
          loop: true,
          allowTouchMove: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            init: function () {
              var buttons = swiperElement.querySelector('.swiper-buttons');
              if (buttons) {
                buttons.style.display = 'block';
              }
            },
          },
        });
      }

    function initializeUninitializedSwipers() {
        var swiperElements = document.querySelectorAll('.swiper:not(.Swiper-initialized)');

        if (!swiperElements || swiperElements.length === 0) {
            return;
        }

        swiperElements.forEach(function (swiperElement) {
            var productId = swiperElement.getAttribute('data-product-id');

            if (!isMobile) {
                toggleSecondSlideDesktop('remove', swiperElement);
            }
            initButtons();
                
            initializeSwiper(swiperElement, productId);
            swiperElement.classList.add('Swiper-initialized');
        });
    }

    function observeDOMChanges() {
        var observer = new MutationObserver(function (mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Itera sobre los nodos agregados en la mutación
                    mutation.addedNodes.forEach(function (node) {
                     
                        // Verifica si el nodo agregado tiene la clase .swiper
                        if (node.classList && node.classList.contains('ProductList') || node.classList && node.classList.contains('Accordion__Item')) {
                            // Si se agregó un elemento con la clase .swiper, inicializa los Swipers nuevamente
                            initializeUninitializedSwipers();
                        }
                    });
                    // Itera sobre los nodos eliminados en la mutación
                    mutation.removedNodes.forEach(function (node) {
                        // Verifica si el nodo eliminado tiene la clase .swiper
                        if (node.classList && node.classList.contains('ProductList') || node.classList && node.classList.contains('Accordion__Item')) {
                            // Si se eliminó un elemento con la clase .swiper, vuelve a inicializar los Swipers
                            initializeUninitializedSwipers();
                        }
                    });
                }
            }
        });
    
        // Observa cambios en todo el documento
        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
        });
    }
    

    initializeUninitializedSwipers();
    observeDOMChanges();

    console.log('Swiper loaded');
});
